import { render, staticRenderFns } from "./examInfo.vue?vue&type=template&id=29218ce7&scoped=true"
import script from "./examInfo.vue?vue&type=script&lang=js"
export * from "./examInfo.vue?vue&type=script&lang=js"
import style0 from "./examInfo.vue?vue&type=style&index=0&id=29218ce7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29218ce7",
  null
  
)

export default component.exports